export default __webpack_public_path__ + "static/media/microsoft_icon.9e816685.svg";